import React from 'react';
import Rating from '@material-ui/lab/Rating';
import Slider from 'react-slick';
import MensMarketing from 'assets/images/Review-Anne-100x0-c-default.jpg';
import {
  Container,
  Wrapper,
  Heading,
  Separator,
  Review,
  Card,
  CardWrapper,
} from 'styles/pages/home/reviews';

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 2,
  initialSlide: 0,
  focusOnSelect: false,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
      },
    },
  ],
};
const Reviews = () => (
  <Container>
    <Wrapper>
      <Heading>What excited Big Oven Tees users are saying</Heading>
      <Separator></Separator>
      <Review>
        <Slider {...settings}>
          <CardWrapper>
            <Card>
              <div>
                <img src={MensMarketing} alt='Marketing' />
                <div>
                  <h3>Anne R.</h3>
                  <h5>Founder, KitschKlothing</h5>
                </div>
              </div>
              <p>
                When I got into this business, I didn’t know what to expect and
                was not even sure if I can make it. It was all new to me and
                seemed quite overwhelming. Big Oven Tees gave me the support I
                needed in those critical first few months and helped me focus on
                design which is what I’m good at!
              </p>
              <Rating value={5} readOnly />
            </Card>
          </CardWrapper>
          <CardWrapper>
            <Card>
              <div>
                <img src={MensMarketing} alt='MensMarketing' />
                <div>
                  <h3>Anne R.</h3>
                  <h5>Founder, KitschKlothing</h5>
                </div>
              </div>
              <p>
                When I got into this business, I didn’t know what to expect and
                was not even sure if I can make it. It was all new to me and
                seemed quite overwhelming. Big Oven Tees gave me the support I
                needed in those critical first few months and helped me focus on
                design which is what I’m good at!
              </p>
              <Rating value={4} readOnly />
            </Card>
          </CardWrapper>
          <CardWrapper>
            <Card>
              <div>
                <img src={MensMarketing} alt='MensMarketing' />
                <div>
                  <h3>Anne R.</h3>
                  <h5>Founder, KitschKlothing</h5>
                </div>
              </div>
              <p>
                When I got into this business, I didn’t know what to expect and
                was not even sure if I can make it. It was all new to me and
                seemed quite overwhelming. Big Oven Tees gave me the support I
                needed in those critical first few months and helped me focus on
                design which is what I’m good at!
              </p>
              <Rating value={3} readOnly />
            </Card>
          </CardWrapper>
          <CardWrapper>
            <Card>
              <div>
                <img src={MensMarketing} alt='MensMarketing' />
                <div>
                  <h3>Anne R.</h3>
                  <h5>Founder, KitschKlothing</h5>
                </div>
              </div>
              <p>
                When I got into this business, I didn’t know what to expect and
                was not even sure if I can make it. It was all new to me and
                seemed quite overwhelming. Big Oven Tees gave me the support I
                needed in those critical first few months and helped me focus on
                design which is what I’m good at!
              </p>
              <Rating value={4} readOnly />
            </Card>
          </CardWrapper>
        </Slider>
      </Review>
    </Wrapper>
  </Container>
);

export default Reviews;
